import { Component, computed, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AccountMenuComponent } from '@components2/shell/sidebar/account-menu/account-menu.component';
import { AvatarModule } from 'primeng/avatar';
import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';

import { CustomerService } from '@services/customer.service';
import { NavService } from '@services/nav.service';
import { UserService } from '@services/user.service';

@Component({
  standalone: true,
  imports: [AccountMenuComponent, PopoverModule, AvatarModule, SkeletonModule],
  selector: 'bk-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent {
  isMobile = input<boolean>(false);
  userService = inject(UserService);
  navService = inject(NavService);
  customerService = inject(CustomerService);

  activeUser = toSignal(this.userService.user$);
  isAdmin = toSignal(this.userService.isAdmin$);
  customer = toSignal(this.navService.selectedCustomer$);

  showAccountMenu = signal(false);

  name = computed(() => {
    const user = this.activeUser();
    if (!user) return '';
    if (!user.firstName || !user.lastName) return user.emailAddress || '';
    return `${user.firstName?.toLocaleUpperCase()} ${user.lastName?.toLocaleUpperCase()}`;
  });

  customerName = computed(() => {
    const customer = this.customer();
    if (!customer) return null;
    return customer.name;
  });

  initials = computed(() => {
    const user = this.activeUser();
    const firstName = user?.firstName;
    const lastName = user?.lastName;
    if (!user || !firstName || !lastName) return '';
    return `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toLocaleUpperCase();
  });
}
